// @flow

import styled from 'styled-components'

export const Container = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 9999;
  width: 280px;
  max-width: calc(100% - 24px);
  padding: 10px 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  font: 12px/1.5 monospace;
  pointer-events: none;
  transform: scale(${({ scale }) => scale || 1});
  transform-origin: top right;
`

export const Title = styled.div`
  margin-bottom: 6px;
  color: #7cfc9b;
  font-weight: bold;
`

export const Note = styled.div`
  color: rgba(255, 255, 255, 0.6);
`

export const StatGroup = styled.div`
  &:not(:first-of-type) {
    margin-top: 6px;
    padding-top: 6px;
    border-top: 1px solid rgba(255, 255, 255, 0.15);
  }
`

export const GroupLabel = styled.div`
  margin-bottom: 3px;
  color: rgba(255, 255, 255, 0.5);
  font-size: 10px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
`

export const StatRow = styled.div`
  display: flex;
  align-items: center;
`

export const Swatch = styled.span`
  flex: 0 0 auto;
  width: 10px;
  height: 10px;
  margin-right: 8px;
  border-radius: 2px;
  background: ${({ color }) => color};
`

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
`

export const LagValue = styled.span`
  color: ${({ ok }) => (ok ? '#7cfc9b' : '#ffd27c')};
`
